//Remove all class from a specific element children
export default function removeClassAllElements(element, className) {
  const elements = element.querySelectorAll(`.${className}`)
  const elementsArray = [].slice.call(elements)
  elementsArray.forEach(el => {
    el.classList.remove(className)
  })
}
